<template>
  <div class="audio-crad-wrapper flex-column-center">
    <div class="card-state">
      <LoaderProgressCircle
        v-if="data.state == 3 || data.id"
        :size="32"
        :loading="renderData.isLoading"
        :default-color="
          renderData.isPlaying ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,1)'
        "
        progress-color="#72FFEC"
        :progress="renderData.progress"
      >
        <div
          class="audio-item-op pointer flex-center"
          @click.stop="doTogglePlay"
        >
          <i
            class="block"
            :class="{
              'isplay-true': !renderData.isPlaying,
              'isplay-false': renderData.isPlaying,
            }"
          ></i>
        </div>
      </LoaderProgressCircle>
      <div
        class="state-fail flex-center"
        v-else-if="data.is_fail"
        @click.stop="handleRetry"
      >
        <img src="@/assets/img/lora/fail.png" alt="" />
      </div>
      <div v-else class="state-fail flex-center">
        <LoaderCircle
          :loading="true"
          :size="16"
          :strokeWidth="2.8"
          color="#fff"
        />
      </div>
    </div>
    <div class="card-show flex">
      <div class="name flex1 olh">{{ data?.name }}</div>
      <div class="close pointer" @click.stop="handleDelete">
        <img src="@/assets/img/lora/delete.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  defineProps,
  defineEmits,
  reactive,
  watch,
  ref,
  onUnmounted,
  getCurrentInstance,
} from "vue";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import LoaderCircle from "@/components/animation/LoaderCircle.vue";
import LoaderProgressCircle from "@/components/animation/LoaderProgressCircle.vue";

const appContext = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext;

const props = defineProps({
  data: {
    type: Object,
    default: () => {},
  },
  state: {
    type: String,
    default: "",
  },
});
const emits = defineEmits(["deleteUpload", "togglePlay"]);

const renderData = reactive({
  isPlaying: false,
  duration: 0,
  progress: 0,
  isLoading: false,
});
const stateData = {};

const init = () => {
  stateData.curPlayerData = appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registerPlayUrl(
    getObjectStorageFullUrl(props.data.url),
    {
      duration: props.data.duration,
      personalizedConfig: {
        loop: false,
        autoToStartIfNotCurrent: true,
      },
      listeners: {
        onPlayStateChange(isPlaying) {
          if (
            getObjectStorageFullUrl(props.data.url) ==
            stateData.curPlayerData?.player?.url
          ) {
            renderData.isPlaying = isPlaying;
          }
        },
        onPositionChange(obj) {
          if (
            getObjectStorageFullUrl(props.data.url) ==
            stateData.curPlayerData?.player?.url
          ) {
            // console.log(obj.progress, "obj.progressobj.progress");
            renderData.progress = obj.progress;
          }
        },
        onLoadingStateChange(isLoading) {
          if (
            getObjectStorageFullUrl(props.data.url) ==
            stateData.curPlayerData?.player?.url
          ) {
            renderData.isLoading = isLoading;
          }
        },
      },
    }
  );
};

const doTogglePlay = () => {
  const isPlay =
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.players[getObjectStorageFullUrl(props.data.url)]
      ?.isPlaying;
  if (isPlay) {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.pause(getObjectStorageFullUrl(props.data.url));
  } else {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.play(getObjectStorageFullUrl(props.data.url), true);
  }
};

// 删除上传
const handleDelete = () => {
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releasePlayer(stateData.curPlayerData);
  emits("deleteUpload");
};

// 重试
const handleRetry = () => {
  emits("retryUpload");
};

watch(
  () => props.data.url,
  () => {
    if (props.data.url) {
      init();
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

onUnmounted(() => {
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releasePlayer(stateData.curPlayerData);
});

</script>

<style lang="scss" scoped>
.audio-crad-wrapper {
  width: 56px;
  height: 56px;
  .card-state {
    width: 32px;
    height: 32px;
    .audio-item-op {
      height: 100%;
      width: 100%;
    }
    i {
      height: 14px;
      width: 14px;
    }
    .isplay-true {
      background: url("@/assets/img/play-light-ico.png");
      background-size: 100% 100%;
    }
    .isplay-false {
      background: url("@/assets/img/pause-light-ico.png");
      background-size: 100% 100%;
    }
    .state-fail {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      background: rgba(0, 0, 0, 0.2);
      img {
        width: 16px;
        height: 16px;
        display: block;
      }
    }
  }
  .card-show {
    width: 100%;
    margin-top: 8px;
    .name {
      color: #fff;
      width: 0;
      font-size: 12px;
      line-height: 12px;
      flex-shrink: 0;
    }
    .close {
      margin-left: 3px;
      img {
        width: 12px;
        height: 12px;
        display: block;
      }
    }
  }
}
</style>
